import Component from '../core/Component'
import { scrollToElement } from '../services/Scroll'

export default class ScrollTo extends Component {

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = event =>  {
        const target = document.getElementById(this.element.getAttribute('href').split('#')[1])

        if (target) {
            event.preventDefault()

            scrollToElement(target, {
                loose: true
            })
        }
    }
}
